import { FormattedMessage } from 'react-intl';

import type { CustomerContractType } from '@/api/schema';
import Input from '@/components/ui/Input';
import { TerminationModal } from '@/features/administration/components/TerminationModal';
import { useDisplayNames } from '@/hooks/useDisplayNames';
import { RIO_CUSTOMER_CENTER } from '@/lib/constants';
import { t } from '@/lib/utils';

export type CompanyContractDataProps = {
    customerContract?: CustomerContractType;
    hasWritePermissions?: boolean;
};

export const CompanyContractData = ({ customerContract, hasWritePermissions }: CompanyContractDataProps) => {
    const formatter = useDisplayNames();

    return (
        <div className='display-flex flex-1-1-0 flex-column margin-bottom-15 bg-white rounded'>
            <div className='display-flex justify-content-between'>
                <div className='text-size-18 text-bold margin-bottom-15'>
                    <FormattedMessage id='chargingContract.personalInfo.title' />
                </div>
            </div>
            <div className='margin-bottom-15'>
                <FormattedMessage tagName='span' id='chargingContract.personalInfo.description' />
            </div>
            <div className='display-grid grid-cols-2 column-gap-15 row-gap-10'>
                {customerContract?.companyName && (
                    <Input
                        label={t('general.companyName')}
                        inputAttributes={{
                            disabled: true,
                            value: customerContract.companyName,
                        }}
                    />
                )}
                {customerContract?.organizationNumber && (
                    <Input
                        label={t('general.companyRegistrationNumber')}
                        inputAttributes={{
                            disabled: true,
                            value: customerContract.organizationNumber,
                        }}
                    />
                )}
                {customerContract?.firstAddressLine && (
                    <Input
                        label={t('general.address')}
                        inputAttributes={{
                            disabled: true,
                            value: customerContract.firstAddressLine,
                        }}
                    />
                )}
                {customerContract?.countryCode && formatter && (
                    <Input
                        label={t('general.country')}
                        inputAttributes={{
                            disabled: true,
                            value: formatter(customerContract.countryCode),
                        }}
                    />
                )}
                {customerContract?.secondAddressLine && (
                    <Input
                        label={t('general.addressOptional')}
                        inputAttributes={{
                            disabled: true,
                            value: customerContract.secondAddressLine,
                        }}
                    />
                )}
                {customerContract?.secondAddressLine && <div />}
                {customerContract?.zip && (
                    <Input
                        label={t('general.postCode')}
                        inputAttributes={{
                            disabled: true,
                            value: customerContract.zip,
                        }}
                    />
                )}
                {customerContract?.city && (
                    <Input
                        label={t('general.city')}
                        inputAttributes={{
                            disabled: true,
                            value: customerContract.city,
                        }}
                    />
                )}
            </div>
            {hasWritePermissions && (
                <>
                    <div className='display-flex flex-column gap-10 margin-top-20'>
                        <span>
                            <strong>
                                <FormattedMessage id='chargingContract.updateCompanyInfo.title' />
                            </strong>
                        </span>
                        <span>
                            <FormattedMessage
                                id='chargingContract.updateCompanyInfo.description'
                                values={{
                                    link: msg => (
                                        <a
                                            className='text-color-primary'
                                            href={RIO_CUSTOMER_CENTER}
                                            target='_blank'
                                            rel='noreferrer'
                                        >
                                            {msg}
                                        </a>
                                    ),
                                }}
                            />
                        </span>
                    </div>
                    <TerminationModal />
                </>
            )}
        </div>
    );
};
